import React from 'react'
import { IoClose } from 'react-icons/io5'

interface AudioLightboxProps {
  isOpen: boolean
  fileUrl: string
  title?: string
  onClose: () => void
}

const AudioLightbox: React.FC<AudioLightboxProps> = ({ isOpen, fileUrl, title, onClose }) => {
  if (!isOpen) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: 'relative',
          width: 'min(560px, 92vw)',
          backgroundColor: '#fff',
          borderRadius: '8px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 14px',
            borderBottom: '1px solid #eee',
            backgroundColor: '#fafafa',
            gap: '10px',
          }}
        >
          <span style={{ fontWeight: 600, fontSize: '14px', color: '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {title || 'Áudio'}
          </span>
          <button
            type="button"
            title="Fechar"
            style={{
              background: '#FA5A84',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '34px',
              height: '34px',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
            onClick={onClose}
          >
            <IoClose size={20} />
          </button>
        </div>
        <div style={{ padding: '20px' }}>
          <audio
            controls
            autoPlay
            src={fileUrl}
            style={{ width: '100%' }}
          >
            Seu navegador não suporta o elemento de áudio.
          </audio>
        </div>
      </div>
    </div>
  )
}

export default AudioLightbox
